import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { numberWithCommas, bedsDisplayString, bathsDisplayString } from 'common/formatters';

import { getListingManagedPhotoUrls, getMarketSecurityDepositLabel } from 'common/listingHelpers';

import { SCREEN_ID_CONNECT_BANK_ACCOUNT_START } from 'client/constants/screenIds';

import ListingActions from 'client/actions/Listing';
import PartnerActions from 'client/actions/Partner';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrPartnerPageV2, {
  SR_PARTNER_PAGE_THEME_BLANK_STATE,
} from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';
import SrSecureTextLabel from 'client/components/SrSecureTextLabel';
import SrPartnerListingCard from 'client/components/SrPartnerListingCard';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_HEIGHT_TALL,
} from 'client/components/SrButton/SrButton';

@withTransitionHook
@withScreenId(SCREEN_ID_CONNECT_BANK_ACCOUNT_START)
@withScrollToTop
@branch({
  listing: ['listing'],
})
@branch(({ listing, match }) => {
  const cursors = {};

  if (match.params.partnerId) {
    cursors.partner = ['partners', 'byId', match.params.partnerId];
  }
  if (listing?.partnerId) {
    cursors.partner = ['partners', 'byId', listing.partnerId];
  }
  if (listing?.marketId) {
    cursors.market = ['markets', 'byId', listing.marketId];
  }

  return cursors;
})
class ConnectBankAccountStartPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Connect Bank Account | Sunroom Rentals',
  });

  static fetchData(match, inject) {
    const listingId = parseInt(match.params.listingId, 10);
    const partnerId = parseInt(match.params.partnerId, 10);

    if (listingId) {
      return ListingActions.getById(inject, listingId).then((listing) => {
        if (listing.partnerId) {
          return PartnerActions.getById(inject, {
            partnerId: listing.partnerId,
          });
        }
      });
    }
    if (partnerId) {
      return PartnerActions.getById(inject, {
        partnerId,
      });
    }
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    listing: PropTypes.object,
    partner: PropTypes.object,
  };

  _getConnectBankFormUrl = () => {
    const {
      match: {
        params: { listingId, partnerId },
      },
    } = this.props;

    return listingId
      ? `/connect-bank/listing/${listingId}/form`
      : `/connect-bank/partner/${partnerId}/form`;
  };

  _onGoToForm = () => {
    const { history } = this.props;
    history.push(this._getConnectBankFormUrl());
  };

  render() {
    const { listing, market, partner } = this.props;
    const [listingPhoto] = getListingManagedPhotoUrls({
      listing,
      useWatermarks: false,
    });

    return (
      <SrPartnerPageV2 navbarImage={partner?.logoUrl} theme={SR_PARTNER_PAGE_THEME_BLANK_STATE}>
        <div>
          <SrBox margin="0 auto 18px auto" width="100%">
            <SrText
              align="center"
              display="block"
              fontSize="27px"
              lineHeight="36px"
              font="greycliff"
              spacing="0"
              weight="600"
            >
              Collect the {getMarketSecurityDepositLabel(market)}
              <br />& fees from renters
            </SrText>
          </SrBox>
          {listing && (
            <SrBox width="335px" margin="0 auto 27px">
              <SrPartnerListingCard
                stats={[
                  `$${numberWithCommas(listing.price)}`,
                  bedsDisplayString(listing),
                  bathsDisplayString(listing),
                  `${numberWithCommas(listing.squareFeet)} ft`,
                ]}
                photos={[listingPhoto]}
                title={listing.addressStreetDisplay}
              />
            </SrBox>
          )}
          <SrBox margin="0 auto" width="263px">
            <SrLink to={this._getConnectBankFormUrl()}>
              <SrButton
                type="button"
                width="263px"
                theme={SR_BUTTON_THEME_ADOBE_GREEN}
                heightType={SR_BUTTON_HEIGHT_TALL}
                hasBoxShadow
              >
                Start Collecting
              </SrButton>
            </SrLink>
            <SrBox paddingTop="10px" textAlign="center">
              <SrSecureTextLabel>Secure Connection</SrSecureTextLabel>
            </SrBox>
          </SrBox>
        </div>
      </SrPartnerPageV2>
    );
  }
}

ConnectBankAccountStartPage.displayName = 'ConnectBankAccountStartPage';

export default ConnectBankAccountStartPage;
